import { styled } from '@mui/material';
import Alert from '@mui/material/Alert';

import { Button } from '~/components/ui/button';
import { COLORS } from '~/styles/colors';

interface StyledItemProps {
  $isDynamicDisabled?: boolean;
}

export const StyledItem = styled('button')<StyledItemProps>(({ $isDynamicDisabled }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  cursor: $isDynamicDisabled ? 'not-allowed' : 'pointer',
  border: `2px solid ${COLORS.white}`,
  borderRadius: '16px',
  padding: '18px',
  gap: '12px',
  boxShadow: '0 0 20px 0 rgba(0, 0, 0, 0.05)',
  backgroundColor: COLORS.white,
  width: '100%',
  height: '100%',
  // aspectRatio: '1/1',

  '&:hover': {
    borderColor: COLORS.primary,
    // backgroundColor: COLORS.white,
    background: 'radial-gradient(972.57% 7936.73% at 50.09% 50%, rgba(4, 135, 230, 0) 0%, #0487E6 100%)',
  },

  '&:disabled': {
    cursor: 'not-allowed',
    opacity: 0.5,
    pointerEvents: 'none',
    '&:hover': {
      borderColor: COLORS.white,
      backgroundColor: COLORS.white,
    },
  },
}));

export const StyledAlert = styled(Alert)(() => ({
  backgroundColor: COLORS.orange2Opacity40,
  border: `1px solid ${COLORS.orange2}`,
  borderRadius: '8px',
  marginTop: '24px',
  alignItems: 'center',
  '.MuiAlert-action': {
    marginRight: '0',
  },
}));

export const StyledAlertGotIt = styled(Button)(() => ({
  backgroundColor: `${COLORS.white} !important`,
  color: `${COLORS.textMain} !important`,
  padding: '4px 20px !important',
}));
